

import Vue from 'vue';
import Component from 'vue-class-component';
import {
    factory,
    RequirementsClient,
    ResultError
} from "@/api-client";
import ErrorsSummary from "@/components/ErrorsSummary.vue";
import toasts from "@/components/Toasts";

@Component({
    components: {
        ErrorsSummary
    },
})
export default class SwedbankPaymentCallback extends Vue {

    applicationId = "";
    requirementId = "";

    paymentProcessed = false;
    paymentSucceeded = false;

    error: ResultError = factory.create(ResultError);

    async created() {
        this.applicationId = this.$route.params.applicationId;
        this.requirementId = this.$route.params.requirementId;

        await new RequirementsClient()
            .swedbankCheckPaymentStatus(this.applicationId, this.requirementId)
            .then(
                () => {
                    this.paymentSucceeded = true;
                    this.paymentProcessed = true;
                    window.setTimeout(this.navigateToRequirementOverview, 1500)
                },
                error => {
                    this.paymentProcessed = true;
                    this.error = error;
                    toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
                });
    }


    navigateToRequirementOverview() {
        this.$router.push({name: 'RequirementOverview', params: {applicationId: this.applicationId, requirementId: this.requirementId, successMessage: "true"}});
    }
}
